import React from 'react'
import { useDrag } from 'react-dnd'
import { ScItemTypes } from '../ScItemTypes'
//import { useDispatch } from 'react-redux' //remove
//import { addDataItem } from '../../../../../features/survey'
import { v4 as uuidv4 } from 'uuid';
import { useEyeconxStore } from '../../../../store/eyeconxStore';
const ScToolbarElement = (props) => {
  //  const dispatch = useDispatch();
    const name = props.element.name
    const type = props.element.type
    const {addDataItem} =useEyeconxStore()

    const [{ isDragging }, drag] = useDrag(() => ({
        type: ScItemTypes.TOOLBUTTON,
        item: { name, type },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                const cardInfo =elementInfo(type,name)
                //dispatch(addDataItem(cardInfo))
                addDataItem(cardInfo)
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }))
    //const opacity = isDragging ? 0.4 : 1
    const handleClick = (name,type) => {
        const cardInfo = elementInfo(type,name)
        //dispatch(addDataItem(cardInfo))
        addDataItem(cardInfo)
    }

    const elementInfo =(etype,name)=>{
        const currId=uuidv4()
        switch (etype){
            case "text":
                return(
                    {
                        id:currId,
                        name:name,
                        type:etype,
                        title:"",
                        description:"",
                        isrequired:false,
                        requiredMessage:"",
                        placeholder:"",
                        maximumLength:"",
                    }
                );
               // break;
            case "comment":
                    return(
                        {
                        id:currId,
                        name:name,
                        type:etype,
                        title:"",
                        description:"",
                        isrequired:false,
                        requiredMessage:"",
                        placeholder:"",
                        maximumLength:"",
                        rows:4,
                        }
                    );
                //break;
            case "checkbox":
                return(
                    {
                    id:currId,
                    name:name,
                    type:etype,
                    title:"",
                    description:"",
                    isrequired:false,
                    requiredMessage:"",
                    choices:[
                        {
                            id:uuidv4(),
                            text:"Choice",
                            value:"Value",
                            isSelected:false,
                        },
                        {
                            id:uuidv4(),
                            text:"Choice",
                            value:"Value",
                            isSelected:false,
                        },
                    ]
                    }
                );
               // break;
            case "radio":
                return(
                    {
                    id:currId,
                    name:name,
                    type:etype,
                    title:"",
                    description:"",
                    isrequired:false,
                    requiredMessage:"",
                    choices:[
                        {
                            id:uuidv4(),
                            text:"Choice",
                            value:"Value",
                            isSelected:true,
                            radiogroup:currId
                        },
                        {
                            id:uuidv4(),
                            text:"Choice",
                            value:"Value",
                            isSelected:false,
                            radiogroup:currId
                        },
                    ]
                    }
                );
               // break;
                
                    
   
        }

    }
   
    return (
        <div
            className="list-group-item list-group-item-action list-group-item-dark"
            ref={drag}
            onClick={()=>handleClick(name,type)}
        >
            <i className={props.element.icon}> </i>
            <span className="text-dark">{props.element.tooltip}</span>
        </div>
    );
}

export default ScToolbarElement;